export default __webpack_public_path__ + "static/media/energie1.5c0c3c6f.jpg";